export class AccountInfoRoutes {

	public static readonly MyCpgRoot: string = 'mycpg';

	public static readonly DependentSegment: string = '/dependent';

	public static readonly RelationshipsSegment: string = '/relationships';

	public static readonly MaritalStatusSegment: string = '/marital-status';

	public static readonly PersonalInfoSegment: string = '/personal-information';

	public static readonly AnnualEnrollment: string = '/annual-enrollment';

	public static readonly PodsDetail: string = '/plan-detail';

	public static readonly MyDocuments: string = '/my-documents';

	public static readonly Midyear: string = '/mid-year-enrollment';

	public static readonly EmploymentSegment: string = '/employment';	

	public static readonly DomesticPartner: string = '/domestic-partner';

	public static readonly DeathOfChild: string = '/death-of-child';

	public static readonly HealthPlanEligibility: string = '/plan-eligibility';

	public static readonly MedicarePartD: string = '/medicare-part-d';
}

